import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from '../component/login.component';
import { SetNewPasswordComponent } from '../component/set-new-password/set-new-password.component';
import { TokenValidityResolver } from '../component/set-new-password/token-validity.resolver';
import { TermsAndConditionsComponent } from '../component/terms-and-conditions/terms-and-conditions.component';


export const LOGIN_URLS = {
  base: 'login',
  _termsAndConditions: 'terms-and-conditions',
  _setNewPassword: 'set-new-password',
};
const routes: Routes = [
  { path: '' , component: LoginComponent },
  {
    path: LOGIN_URLS._setNewPassword + '/:token',
    component: SetNewPasswordComponent,
    resolve: { isTokenValid: TokenValidityResolver },
  },

  {
    path: LOGIN_URLS._termsAndConditions,
    component: TermsAndConditionsComponent,
  },

];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoginRoutingModule {}
